// app/javascript/modules/admissoes/horario_escala.js

export function initHorarioEscala($form, h) {
  const { hide, show } = h || {}

  // ✅ sempre retorna { apply, destroy } (pra não quebrar o Stimulus)
  if (!$form || !$form.length) {
    return { apply() { }, destroy() { } }
  }

  function setRequired($el, required) {
    if (!$el || !$el.length) return
    if (required) {
      $el.attr("required", "required")
      $el.attr("aria-required", "true")
    } else {
      $el.removeAttr("required")
      $el.removeAttr("aria-required")
    }
  }

  function setEnabled($el, enabled, { clearOnDisable = false } = {}) {
    if (!$el || !$el.length) return
    $el.prop("disabled", !enabled)
    // readonly ajuda em inputs que têm máscara
    $el.prop("readonly", !enabled)

    if (!enabled && clearOnDisable) {
      $el.val("") // ✅ não dispara eventos
    }
  }

  function clearValueNoEvents($input) {
    if (!$input || !$input.length) return
    $input.val("") // ✅ NÃO dispara change/input (evita loop)
  }

  function findWrapper($input, fallbackSel) {
    let $w = $form.find(fallbackSel).first()
    if ($w.length) return $w

    if ($input && $input.length) {
      $w = $input.closest(".keep-space-when-hidden")
      if ($w.length) return $w
      $w = $input.closest(".min-w-0")
      if ($w.length) return $w
      $w = $input.closest(".linha-field")
      if ($w.length) return $w
      // fallback final
      $w = $input.closest(".mb-4")
      if ($w.length) return $w
    }

    return $w
  }

  function doShow($w) {
    if (!$w || !$w.length) return
    if (typeof show === "function") show($w)
    else $w.removeClass("hidden").show()
  }

  function doHide($w) {
    if (!$w || !$w.length) return
    if (typeof hide === "function") hide($w)
    else $w.addClass("hidden").hide()
  }

  // ✅ wrapper oculta, mas mantendo espaço (se você quiser)
  // hoje vocês usam `.keep-space-when-hidden.hidden { visibility:hidden; display:block; }`
  // então a forma correta é aplicar `.hidden` no wrapper que já tem `keep-space-when-hidden`
  function hideKeepingSpace($w) {
    if (!$w || !$w.length) return
    $w.addClass("hidden")
  }

  function showKeepingSpace($w) {
    if (!$w || !$w.length) return
    $w.removeClass("hidden")
  }

  function bindToggle({ chkSel, selectSel, inputSel, wrapperSel, ns, afterApply }) {
    const $chk = $form.find(chkSel).first()
    if (!$chk.length) return null

    const $select = $form.find(selectSel).first()
    const $input = $form.find(inputSel).first()

    // wrapper preferido: selector explícito; senão tenta achar pelo input
    const $wrapExplicit = $form.find(wrapperSel).first()
    const $wrap = ($wrapExplicit.length ? $wrapExplicit : findWrapper($input, wrapperSel))

    const apply = () => {
      const checked = $chk.is(":checked")

      // quando "outra_*" marcado: select NÃO é required; input permanece opcional
      if ($select.length) setRequired($select, !checked)

      // ✅ select desabilita quando checked
      if ($select.length) {
        setEnabled($select, !checked, { clearOnDisable: checked })
        if (checked) $select.val("") // sem eventos
      }

      // ✅ input habilita quando checked; required apenas quando visível
      if ($input.length) {
        setEnabled($input, checked, { clearOnDisable: !checked })
        setRequired($input, checked)
        if (!checked) clearValueNoEvents($input)
      }

      // ✅ show/hide do wrapper
      if ($wrap.length) {
        if (checked) {
          // mostra (sem deslocamentos / sem classe errada)
          if ($wrap.hasClass("keep-space-when-hidden")) showKeepingSpace($wrap)
          else doShow($wrap)
        } else {
          // esconde
          if ($wrap.hasClass("keep-space-when-hidden")) hideKeepingSpace($wrap)
          else doHide($wrap)
        }
      } else if ($wrapExplicit.length) {
        // fallback (caso o wrapperSel exista)
        checked ? doShow($wrapExplicit) : doHide($wrapExplicit)
      }

      if (afterApply) afterApply(checked)
    }

    $chk.off(`change.${ns}`).on(`change.${ns}`, apply)
    return { apply, destroy: () => $chk.off(`.${ns}`) }
  }

  // --- Adicional noturno ---

  // Noturno = qualquer hora >= 22 ou <= 5, ou turno que cruza meia-noite (início > fim)
  function isNoturno(horarioStr) {
    if (!horarioStr || !horarioStr.trim()) return false
    const matches = [...horarioStr.matchAll(/(\d{1,2}):\d{2}/g)]
    if (!matches.length) return false
    const hours = matches.map(m => parseInt(m[1], 10))
    if (hours.some(h => h >= 22 || h <= 5)) return true
    // turno que cruza meia-noite: primeiro horário > último (ex: 19:00-07:00)
    if (hours.length >= 2 && hours[0] > hours[hours.length - 1]) return true
    return false
  }

  function syncAdicionalNoturno() {
    const $secao   = $form.find("#secao-adicional-noturno")
    if (!$secao.length) return

    const outraHorario = $form.find("#params_outra_horario").is(":checked")
    const horarioVal   = outraHorario
      ? $form.find("#params_nova_horario").val()
      : $form.find("#params_horario").val()

    const noturno = isNoturno(horarioVal)

    const $radios = $secao.find('input[type="radio"]')
    if (noturno) {
      $secao.show()
      // Remove skip para que setFormDisabled possa gerenciar normalmente
      $radios.removeAttr("data-skip-disable")
      // marca "Sim" e bloqueia visualmente (pointer-events desativa clique;
      // "Sim" fica enabled pra ser submetido, "Não" fica disabled)
      $radios.filter('[value="Sim"]').prop("checked", true).prop("disabled", false)
      $radios.filter('[value="Não"]').prop("checked", false).prop("disabled", true)
      $secao.css("pointer-events", "none").find(".mb-4").addClass("opacity-60 select-none")
    } else {
      $secao.hide()
      // "Não" fica habilitado e marcado para ser enviado no submit (servidor sempre exige o campo)
      // "Sim" fica desabilitado com data-skip-disable para que setFormDisabled não o reabilite
      $radios.filter('[value="Não"]').prop("checked", true).prop("disabled", false).removeAttr("data-skip-disable")
      $radios.filter('[value="Sim"]').prop("checked", false).prop("disabled", true).attr("data-skip-disable", "true")
      $secao.css("pointer-events", "").find(".mb-4").removeClass("opacity-60 select-none")
    }
  }

  function syncAlertaRevisao() {
    const $alert = $form.find(".nova-horario-alerta")
    if (!$alert.length) return
    const algumMarcado = $form.find("#params_outra_escala").is(":checked") ||
                         $form.find("#params_outra_horario").is(":checked")
    algumMarcado ? $alert.removeClass("hidden") : $alert.addClass("hidden")
  }

  function syncHorarioSelect() {
    const $wrapper = $form.find("#secao-horario-row")
    if (!$wrapper.length) return

    const $escalaSel  = $form.find("#params_escala")
    const outraEscala = $form.find("#params_outra_escala").is(":checked")
    const escalaVal   = $escalaSel.val() || ""

    if (!escalaVal && !outraEscala) {
      doHide($wrapper)
      $form.find("#params_horario").val("")
      return
    }

    doShow($wrapper)

    const $horarioSel = $form.find("#params_horario")
    if (!$horarioSel.length) return

    // Cache original options on first call
    if (!$horarioSel.data("allOpts")) {
      $horarioSel.data("allOpts", $horarioSel.find("option").map(function() {
        return { v: this.value, t: this.text }
      }).get())
    }

    const allOpts           = $horarioSel.data("allOpts")
    const horariosPorEscala = $wrapper.data("horarios-por-escala") || {}
    // null = show all options; array = filter to only these
    const horariosEscala    = (!outraEscala && escalaVal) ? (horariosPorEscala[escalaVal] || []) : null
    const currentVal        = $horarioSel.val()

    $horarioSel.empty()
    allOpts.forEach(({ v, t }) => {
      if (!v || !horariosEscala || horariosEscala.includes(v)) {
        $horarioSel.append(new Option(t, v))
      }
    })

    const stillAvailable = currentVal && $horarioSel.find("option").filter(function() {
      return this.value === currentVal
    }).length > 0
    $horarioSel.val(stillAvailable ? currentVal : "")
  }

  const t1 = bindToggle({
    chkSel: "#params_outra_horario",
    selectSel: "#params_horario",
    inputSel: "#params_nova_horario",
    wrapperSel: ".params_nova_horario",
    ns: "admOutroHorario",
    afterApply: () => { syncAlertaRevisao(); syncAdicionalNoturno() },
  })

  const t2 = bindToggle({
    chkSel: "#params_outra_escala",
    selectSel: "#params_escala",
    inputSel: "#params_nova_escala",
    wrapperSel: ".params_nova_escala",
    ns: "admOutraEscala",
    afterApply: () => { syncAlertaRevisao(); syncHorarioSelect() },
  })

  $form.on("change.admHorarioNoturno", "#params_horario", syncAdicionalNoturno)
  $form.on("input.admHorarioNoturno change.admHorarioNoturno", "#params_nova_horario", syncAdicionalNoturno)
  $form.on("change.admHorarioSelect", "#params_escala", syncHorarioSelect)

  function apply() {
    try { t1 && t1.apply && t1.apply() } catch (_e) { }
    try { t2 && t2.apply && t2.apply() } catch (_e) { }
    syncAdicionalNoturno()
    syncHorarioSelect()
  }

  function destroy() {
    try { t1 && t1.destroy && t1.destroy() } catch (_e) { }
    try { t2 && t2.destroy && t2.destroy() } catch (_e) { }
    $form.off(".admHorarioNoturno")
    $form.off(".admHorarioSelect")
  }

  // ✅ aplica uma vez no init
  apply()

  return { apply, destroy }
}
